import { render, staticRenderFns } from "./ElementFormGroup.vue?vue&type=template&id=2887cec8&"
import script from "./ElementFormGroup.vue?vue&type=script&lang=js&"
export * from "./ElementFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./ElementFormGroup.vue?vue&type=style&index=0&id=2887cec8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports